// 常量配置
export default {
  PRJ: ["bmw", "ctd", "cd", "scts", "Acer", "sctsnew", "ys", "Asus"],
  F_SRC: {
    th_order: "thd",
    th_demage: "thpsd",
    ps_order: "psd",
    ps_demage: "pspsd",
    transfer: "zzd"
  },
  SUBDIR: {
    th: "th",
    ps: "ps",
    abn: "abn"
  }
};



// WEBPACK FOOTER //
// ./src/config/config.js